import React from 'react'
import { Outlet } from 'react-router-dom'

function Footer() {
    return (
        <>
            <div className='footer'>
                <div className='container'>
                    <p>
                        <b>Disclaimer</b> - This website does not claim ownership of any information displayed here. All data is sourced from third-party APIs, and we do not guarantee its accuracy or completeness. Movie details may vary, and we recommend verifying information from official sources.
                    </p>
                </div>
            </div>
            <Outlet />
        </>
    )
}

export default Footer